import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { CartIcon } from './CartIcon';

export function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-blue-700 text-white navbar">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="text-3xl font-bold tracking-tight">
            VHOLIC <span className="text-yellow-400">APPLIANCES</span>
          </Link>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <nav className="flex space-x-6">
              <Link 
                to="/" 
                className={`font-medium ${isActive('/') ? 'text-yellow-400' : 'hover:text-yellow-400'}`}
              >
                Home
              </Link>
              <Link 
                to="/shop" 
                className={`font-medium ${isActive('/shop') ? 'text-yellow-400' : 'hover:text-yellow-400'}`}
              >
                Shop
              </Link>
              <Link 
                to="/track-order" 
                className={`font-medium ${isActive('/track-order') ? 'text-yellow-400' : 'hover:text-yellow-400'}`}
              >
                Track Order
              </Link>
            </nav>
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-2">
                <Phone className="w-5 h-5" />
                <span className="font-medium">909‑990‑9090</span>
              </div>
              <Link 
                to="/cart" 
                className={`hover:text-yellow-400 transition-colors duration-200 ${
                  isActive('/cart') ? 'text-yellow-400' : ''
                }`}
                aria-label="Shopping Cart"
              >
                <CartIcon />
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`md:hidden transition-all duration-300 ease-in-out ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden`}
        >
          <nav className="flex flex-col space-y-4 pb-6">
            <Link 
              to="/" 
              className={`font-medium ${isActive('/') ? 'text-yellow-400' : 'hover:text-yellow-400'}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/shop" 
              className={`font-medium ${isActive('/shop') ? 'text-yellow-400' : 'hover:text-yellow-400'}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Shop
            </Link>
            <Link 
              to="/track-order" 
              className={`font-medium ${isActive('/track-order') ? 'text-yellow-400' : 'hover:text-yellow-400'}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Track Order
            </Link>
            <div className="flex items-center space-x-2 pt-2">
              <Phone className="w-5 h-5" />
              <span className="font-medium">909‑990‑9090</span>
            </div>
          </nav>
        </div>

        {/* Mobile Menu Backdrop - Hidden when menu is closed */}
        {isMobileMenuOpen && (
          <div 
            className="mobile-menu-backdrop fixed inset-0 bg-black bg-opacity-25 z-30 md:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}
      </div>
    </header>
  );
}